<div fxLayout="row">
  <app-avatar-account
    fxFlex="60px"
    class="u-display-block"
    [item]="account"
    [size]="48"
  ></app-avatar-account>
  <div fxFlex="1 1 calc(100% - 60px)">
    <div class="u-marginBottom-16">
      <a
        [routerLink]="['/profile', account.slug]"
        class="color-blue u-textDecoration-underline--hover"
      >
        <h6>
          <b>{{ account | appAccountFullName }}</b>
          <span
            *ngIf="account | appDisplayUserPronouns"
            class="color-grey-300 u-textTruncate text-subtitle-1 u-wordWrap-breakWord"
            >{{ account | appDisplayUserPronouns }}</span
          >
        </h6>
      </a>
      <div
        *ngIf="!!account.short_bio"
        [ngStyle]="{ height: '21px' }"
        class="color-grey-300 u-textTruncate u-wordWrap-breakWord"
      >
        {{ account.short_bio }}
      </div>
    </div>
    <div class="u-marginBottom-8">
      <mat-chip-list>
        <mat-chip class="mat-chip--small">
          {{ connectionHighlightsRole }}
        </mat-chip>
        <mat-chip
          *ngFor="let highlight of connectionHighlightsCustomSegments"
          class="mat-chip--small"
        >
          {{ highlight }}
        </mat-chip>
      </mat-chip-list>
    </div>
  </div>
</div>
